import React, { useState } from 'react'
import { Button, Spin, Modal, Form, Input, Checkbox, message } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { stockroomSelector, createStockroomAction } from '../../../store/stockroom'
import ProjectSelector from '../../ProjectSelector'

const messageKey = 'add_new_stockroom'

const AddStockroomModal = ({ showModal, onCancel, onFinish }) => {
  const dispatch = useDispatch()
  const { isFetching } = useSelector(stockroomSelector)
  const [form] = Form.useForm()

  const [isCentral, setCentral] = useState(false)

  const clear = () => {
    form.resetFields()
    setCentral(false)
  }

  const onCancelClick = () => {
    onCancel()
    clear()
  }

  const onFinishCallback = async ({ name, project, isCentral }) => {
    try {
      const newStockroom = await dispatch(createStockroomAction({ name, project, isCentral })).unwrap()
      message.success({
        key: messageKey,
        content: `Склад '${newStockroom.result?.name}' добавлен успешно`,
      })
      onFinish()
      clear()
    } catch (err) {
      const { name, status, message: errorMessage } = err.error
      message.error({
        key: messageKey,
        content: `Ошибка (${name}, статус: ${status}): '${errorMessage}' `,
      })
    }
  }

  return (
    <Modal
      title="Новый склад"
      visible={showModal}
      onCancel={onCancelClick}
      footer={[
        <Button key="back" onClick={onCancelClick}>
          Отмена
        </Button>,
        <Button key="save" type="primary" onClick={() => form.submit()}>
          Добавить
        </Button>,
      ]}
    >
      <Spin spinning={isFetching}>
        <Form
          name="new-stockroom"
          initialValues={{ isCentral: false }}
          autoComplete="off"
          layout="horizontal"
          onFinish={onFinishCallback}
          form={form}
          size="large"
        >
          <Form.Item
            label="Название склада"
            name="name"
            labelCol={{ span: 24 }}
            rules={[{ required: true, message: 'Поле обязательно' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item label="Центральный склад" name="isCentral" valuePropName="checked" initialValue={false}>
            <Checkbox onChange={(e) => setCentral(e.target.checked)} />
          </Form.Item>
          <Form.Item label="Проект" name="project" labelCol={{ span: 24 }}>
            <ProjectSelector disabled={isCentral} />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  )
}

export default AddStockroomModal
